var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11C18 8.172 18 6.757 17.121 5.879C16.243 5 14.828 5 12 5H9C6.172 5 4.757 5 3.879 5.879C3 6.757 3 8.172 3 11V16C3 18.828 3 20.243 3.879 21.121C4.757 22 6.172 22 9 22H12C14.828 22 16.243 22 17.121 21.121C18 20.243 18 18.828 18 16V11Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19C18.7956 19 19.5587 18.6839 20.1213 18.1213C20.6839 17.5587 21 16.7956 21 16V10C21 6.229 21 4.343 19.828 3.172C18.656 2.001 16.771 2 13 2H9C8.20435 2 7.44129 2.31607 6.87868 2.87868C6.31607 3.44129 6 4.20435 6 5",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};
export default SvgCopy;